<header class="header " [class.active]="isActive">
  <div class="inner-section inner-header">
    <a [href]="environment.portalOnfUrl"  class="header-logo">
      <img src="assets/images/ui-kit-img/logo.svg" alt="header-logo"/>
    </a>
    <nav class="header-menu">
      <ul>
        @for ( item  of  tabs()?.topHeader; track  item) {
          <li><a [href]='item.url' [target]="item.openInNewTab ? '_blank' : '_self' " >{{item.name}}</a></li>
        }
      </ul>
    </nav>

    <div class="contacts">
      <div class="header-contacts-item">
        <div class="contact-item-static">16+</div>
        <div class="mobile-menu-toggler contact-item" (click)="openMenu()" >
        </div>

        <div class="contact-item header-login" >
          <a (click)="login()" target="_self" >
            <button class="dropdown-toggle" type="button">
              <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_1300_8570" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                  <rect width="32" height="32" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_1300_8570)">
                  <path d="M7.8013 22.7993C8.93464 21.9327 10.2013 21.2493 11.6013 20.7493C13.0013 20.2493 14.468 19.9993 16.0013 19.9993C17.5346 19.9993 19.0013 20.2493 20.4013 20.7493C21.8013 21.2493 23.068 21.9327 24.2013 22.7993C24.9791 21.8882 25.5846 20.8549 26.018 19.6993C26.4513 18.5438 26.668 17.3105 26.668 15.9993C26.668 13.0438 25.6291 10.5271 23.5513 8.44935C21.4735 6.37157 18.9569 5.33268 16.0013 5.33268C13.0457 5.33268 10.5291 6.37157 8.4513 8.44935C6.37352 10.5271 5.33464 13.0438 5.33464 15.9993C5.33464 17.3105 5.5513 18.5438 5.98464 19.6993C6.41797 20.8549 7.02352 21.8882 7.8013 22.7993ZM16.0013 17.3327C14.6902 17.3327 13.5846 16.8827 12.6846 15.9827C11.7846 15.0827 11.3346 13.9771 11.3346 12.666C11.3346 11.3549 11.7846 10.2493 12.6846 9.34935C13.5846 8.44935 14.6902 7.99935 16.0013 7.99935C17.3124 7.99935 18.418 8.44935 19.318 9.34935C20.218 10.2493 20.668 11.3549 20.668 12.666C20.668 13.9771 20.218 15.0827 19.318 15.9827C18.418 16.8827 17.3124 17.3327 16.0013 17.3327ZM16.0013 29.3327C14.1569 29.3327 12.4235 28.9827 10.8013 28.2827C9.17908 27.5827 7.76797 26.6327 6.56797 25.4327C5.36797 24.2327 4.41797 22.8216 3.71797 21.1993C3.01797 19.5771 2.66797 17.8438 2.66797 15.9993C2.66797 14.1549 3.01797 12.4216 3.71797 10.7993C4.41797 9.17713 5.36797 7.76602 6.56797 6.56602C7.76797 5.36602 9.17908 4.41602 10.8013 3.71602C12.4235 3.01602 14.1569 2.66602 16.0013 2.66602C17.8457 2.66602 19.5791 3.01602 21.2013 3.71602C22.8235 4.41602 24.2346 5.36602 25.4346 6.56602C26.6346 7.76602 27.5846 9.17713 28.2846 10.7993C28.9846 12.4216 29.3346 14.1549 29.3346 15.9993C29.3346 17.8438 28.9846 19.5771 28.2846 21.1993C27.5846 22.8216 26.6346 24.2327 25.4346 25.4327C24.2346 26.6327 22.8235 27.5827 21.2013 28.2827C19.5791 28.9827 17.8457 29.3327 16.0013 29.3327Z" fill="#E60000"/>
                </g>
              </svg>
            </button>
          </a>
          @if (isAuth){
              <div class="authMenu">
                <div class="authMenuBlock">
                  @if (profileInfo()){
                    <p class="authMenu__title">Здравствуйте, <span> {{
                        (profileInfo()!.person.name.last ? profileInfo()!.person.name.first + ' ' : '')
                      }}</span></p>
                  }


                  <ul>
                      <a [href]="environment.portalOnfUrl + '/lk'">
                        <li   class="authMenu__items">
                          <img class="authMenu__wrap__img" src="../../../assets/images/ui-kit-img/person.svg" alt="menu_person">
                          <span>Личный кабинет</span>
                        </li>
                      </a>
                    <li (click)="logout()" class="authMenu__items" >
                      <img class="authMenu__wrap__img" src="../../../assets/images/ui-kit-img/logout.svg" alt="menu_logout">
                      <span>Выйти</span>
                    </li>
                  </ul>
                  @if (profileInfo()){
                    <p class="authMenu__loginId">ID:{{profileInfo()!.person.id}}</p>
                  }
                </div>
              </div>
            }
      </div>
    </div>
  </div>
  </div>
  <div class="header-dinamic-block">
    <div class="header-block-menu-left"></div>
    <nav class="header-dinamic-menu">
      <ul>
        @for ( item  of  tabs()?.secondHeader; track  item) {
          <li><a [href]='item.url' [target]="item.openInNewTab ? '_blank' : '_self' " >{{item.name}}</a></li>
        }
      </ul>
    </nav>
    <div class="header-block-menu-right"></div>
  </div>

</header>

